/* eslint-disable react/destructuring-assignment */
import React from "react"
import { useSelector } from "react-redux"

import {
    StoreType,
    LangType,
} from "client/store"
import {
    HistoryProps,
    HistoryType,
} from "client/components"
import {
    Remark,
    Bold,
} from "./styled"

export const HistoryRemark = ({
    history,
}: HistoryProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    let remark = history.remark && history.remark.trim()
    remark = remark && remark.length > 0 ? remark : null

    if (!remark) return null
    return (
        <Remark>
            <Bold>{`${lang.remark}:`}</Bold>
            {remark}
        </Remark>
    )
}

export const HistoryRemarkPdfExport = (
    history: HistoryType,
    lang: LangType,
) => {
    let remark = history.remark && history.remark.trim()
    remark = remark && remark.length > 0 ? remark : null

    if (!remark) return null
    return ({
        text: [
            {
                text: `${lang.remark}: `,
                bold: true,
            },
            { text: remark },
        ],
    })
}
